'use strict';
var UserService = /** @class */ (function () {
    /*@ngInject*/
    function UserService($http, $q) {
        this.audience = 'none';
        this._$http = $http;
        this.$q = $q;
    }
    UserService.prototype.handleError = function (response) {
        this.$q.reject();
        return response;
    };
    /*@ngInject*/
    UserService.prototype.getAudience = function () {
        return this.audience;
    };
    UserService.prototype.setAudience = function (audience) {
        this.audience = audience;
    };
    UserService.prototype.get = function (cache) {
        return this._$http({
            method: 'GET',
            url: 'api/account',
            cache: true,
        })
            .then(function (response) {
            return response;
        }, this.handleError);
    };
    return UserService;
}());
export default UserService;
//# sourceMappingURL=user.service.js.map